import PropTypes from 'prop-types';

const {
  bool,
  shape,
  string,
  arrayOf,
  number
} = PropTypes;
const unitType = {
  title: string.isRequired,
  titleHighlights: arrayOf(shape({
    length: number.isRequired,
    offset: number.isRequired
  })),
  description: string,
  descriptionHighlights: arrayOf(shape({
    length: number.isRequired,
    offset: number.isRequired
  })),
  completionTime: string.isRequired,
  complete: bool,
  path: string.isRequired,
  labels: shape({
    completed: string.isRequired,
    incomplete: string.isRequired
  }),
  a11yHidden: bool
};
const defaultUnitType = {
  description: null,
  descriptionHighlights: null,
  titleHighlights: null,
  complete: false,
  unitsInitiallyExpanded: false,
  a11yHidden: false
};
var unitType$1 = unitType;

export { unitType$1 as default, defaultUnitType };
